import { createRoot } from 'react-dom/client'
import { HelmetProvider } from 'react-helmet-async'
import App from './App.tsx'
import './index.css'

const bootstrapApp = () => {
  createRoot(document.getElementById("root")!).render(
    <HelmetProvider><App /></HelmetProvider>
  );
};

const clearLegacyServiceWorkers = async () => {
  if (typeof window === 'undefined' || !('serviceWorker' in navigator)) {
    return;
  }

  try {
    const registrations = await navigator.serviceWorker.getRegistrations();
    await Promise.all(registrations.map((registration) => registration.unregister()));

    if ('caches' in window) {
      const cacheKeys = await caches.keys();
      await Promise.all(cacheKeys.map((key) => caches.delete(key)));
    }
  } catch (error) {
    console.warn('Failed to clear legacy service workers:', error);
  }
};

bootstrapApp();
void clearLegacyServiceWorkers();
